<template>
  <div class="portfolio-container">
    <Header />
    <div class="portfolio-content">
      <iframe 
        src="/portfolio/"
        title="Profetto UI"
        class="portfolio-iframe"
      />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';

export default {
  name: 'PortfolioView',
  components: {
    Header,
  },
};
</script>

<style lang="scss" scoped>
.portfolio-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
}

.portfolio-content {
  flex: 1;
  overflow: hidden;
}

.portfolio-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
